var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4677 1.09817C19.744 0.612175 18.8724 0.95233 18.8132 1.742C18.7794 2.19384 18.7489 2.76905 18.7291 3.49595C14.2151 3.57997 7.11254 3.57997 7.11254 3.57997C4.33852 3.57997 2.08972 5.7856 2.08972 8.22015V11.7986C2.08972 12.4543 2.40906 13.1077 3.15201 13.2453C3.807 13.3667 4.60219 13.3667 5.25717 13.2453C6.00013 13.1077 6.31947 12.4543 6.31947 11.7986V8.45215C6.31947 7.81145 6.91125 7.2921 7.64127 7.2921C7.64127 7.2921 14.3078 7.2921 18.7344 7.3756C18.7541 8.0154 18.7823 8.5308 18.8132 8.94335C18.8724 9.73315 19.7442 10.0733 20.468 9.58725C20.9845 9.24045 21.6469 8.76895 22.4691 8.1361C23.8075 7.1059 24.5113 6.3606 24.8729 5.90035C25.1438 5.55545 25.1438 5.1304 24.8728 4.78551C24.5112 4.32528 23.8075 3.58003 22.4691 2.54968C21.6467 1.91662 20.9842 1.44498 20.4677 1.09817Z",
    fill: "#0157FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63617 22.9022C9.35987 23.3882 10.2315 23.048 10.2907 22.2584C10.3245 21.8065 10.3551 21.2313 10.3748 20.5044C14.8888 20.4204 21.9914 20.4204 21.9914 20.4204C24.7654 20.4204 27.0142 18.2147 27.0142 15.7802V12.2017C27.0142 11.546 26.6949 10.8927 25.9519 10.755C25.2969 10.6337 24.5017 10.6337 23.8467 10.755C23.1037 10.8927 22.7844 11.546 22.7844 12.2017V15.5482C22.7844 16.1889 22.1927 16.7083 21.4626 16.7083C21.4626 16.7083 14.7961 16.7083 10.3695 16.6247C10.3498 15.985 10.3216 15.4696 10.2907 15.057C10.2315 14.2672 9.3597 13.927 8.63588 14.4131C8.11944 14.7599 7.45698 15.2314 6.63483 15.8642C5.29636 16.8945 4.59265 17.6398 4.23103 18.1C3.96007 18.4449 3.96011 18.87 4.2311 19.2149C4.59273 19.6751 5.29644 20.4203 6.63483 21.4507C7.45716 22.0837 8.11979 22.5554 8.63617 22.9022Z",
    fill: "#0157FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.47095e57b95fd7d1836e107f613b4d5c.svg";
export { ForwardRef as ReactComponent };